// import {LoaderDiv} from '@components/card/CardComponentStyles';
import SnackBarConfig from '@components/snackbar/SnackbarConfig';
// import {CircularProgress} from '@mui/material';
import {getSearchForm} from '@shared/services/service-handlers/PrivateService';
import {getErrorMessage} from '@shared/utils/ErrorUtils';
import {useSnackbar} from 'notistack';
import {useEffect, useState} from 'react';
import TabsComponent from '../../sub-modules-menu/tabsComponent/TabsComponent';
import {useAppContext} from '@context/AppContext';

interface AuditTrailComponentProps {
  module: string;
}

const AuditTrailComponent = (props: AuditTrailComponentProps): JSX.Element => {
  const {
    appState: {applicationName}
  } = useAppContext();

  const {enqueueSnackbar} = useSnackbar();
  const [tabData, setTabData] = useState({});
  const [loader, setLoader] = useState(false);

  const init = async () => {
    try {
      if (props.module) {
        setLoader(true);
        const res = await getSearchForm(applicationName, props.module);
        setTabData(res.searchForm);
        setLoader(false);
      }
    } catch (e) {
      const errMessage = getErrorMessage(e);
      enqueueSnackbar(errMessage, SnackBarConfig.getError());
      setLoader(false);
    }
  };
  useEffect(() => {
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.module]);

  return (
    <div>
      {/* {!loader && tabData && Object.keys(tabData).length ? ( */}
      <TabsComponent
        sectionUIData={tabData}
        sectionRowsData={[]}
        module={props?.module}
        isLoading={loader}
      />
      {/* ) : (
        <LoaderDiv>
          <CircularProgress />
        </LoaderDiv>
      )} */}
    </div>
  );
};

export default AuditTrailComponent;
